import React from 'react';
import styles from '@/pages/task-list/styles.less';
import { Header, Body, EditQuestions } from '@/pages/task-list/components/index';
import { Switch } from 'react-router-dom';
import { Route, routes } from '@/app/routing/index';
import TaskDetails from '@/common/containers/TaskDetails/index';

const TaskList = () => {
  return (
    <Switch>
      <Route path={`${routes.dashboard.taskDetails}/:id`}>
        <div className={styles.page}>
          <Header />
          <TaskDetails />
        </div>
      </Route>
      <Route
        path={routes.dashboard.editQuestions}
        component={EditQuestions}
        exact
      />
      <Route path={`${routes.dashboard.taskList}/:tab`}>
        <div className={styles.page}>
          <Header />
          <Body />
        </div>
      </Route>
    </Switch>
  );
};

export default TaskList;
